import React from "react";
import { Flex, QRCode } from "antd";
import Paragraph from "antd/es/typography/Paragraph";
import Title from "antd/es/typography/Title";
import Barcode from "react-barcode";
import { useTranslation } from "react-i18next";
import CustomCard from "../../../../components/CustomCard";
import { memberType } from "../../../../types/member";
import { getDate } from "../../../../utils/getDate";

type BarcodeCardProps = {
  data: memberType;
  preview?: boolean;
};

const BarcodeCard: React.FC<BarcodeCardProps> = ({
  data,
  preview = false,
}: BarcodeCardProps) => {
  const { t } = useTranslation();
  return (
    <CustomCard
      headerBorderRadius={(!data.barcode_type || !data.is_enabled_barcode)
        ? "12" : undefined}
      fillColor={"var(--app-foreground-color)"}
      title={
        <Flex vertical gap={"small"} style={{ padding: "20px 16px 20px 16px" }}>
          <Title
            level={2}
            style={{ color: "#fff" }}
            className="text-center  h1-bold"
          >
            {preview ? t(data.name) : t("{{ member_name }}", { member_name: data.name }) || "-"}
          </Title>
          {data.member_level && data.show_member_level && (
            <Flex justify="center" gap={"8px"}>
              <Paragraph className="text-center text-white note-bold">
                {t("Membership level:")} {
                  data.enable_member_level_name && data.member_level_name_mapping && data.member_level_name_mapping[data.member_level]
                    ? data.member_level_name_mapping[data.member_level]
                    : t(data.member_level)
                }
              </Paragraph>
            </Flex>
          )}
          {(data.start_date || data.end_date) && (
            <Flex justify="center" gap={"8px"}>
              <Paragraph className="text-center text-white note-regular">
                {getDate(data.start_date)} - {getDate(data.end_date)}
              </Paragraph>
            </Flex>
          )}
        </Flex>
      }
    >
      {(!data.barcode_type || !data.is_enabled_barcode) ? null : (
        <Flex
          justify="center"
          style={{ padding: "20px 16px 20px 16px" }}
          gap={"20px"}
        >
          {String(data.barcode_value) && data.is_enabled_barcode && data.barcode_type ? (
            <Flex
              vertical
              style={{ padding: 0 }}
              justify="center"
              align="center"
              className="w-[260px]"
            >
              {data.barcode_type === "QRCODE" ? (
                <QRCode color="#223B53" value={String(data.barcode_value)} />
              ) : (
                <div className="barcode-container">
                  <Barcode
                    width={1.5}
                    fontSize={12}
                    textMargin={10}
                    format={data.barcode_type}
                    font="Roboto"
                    value={String(data.barcode_value)}
                  />
                </div>
              )}
            </Flex>
          ) : (
            <Paragraph className="text-center note-regular">
              {t("No barcode data")}
            </Paragraph>
          )}
        </Flex>
      )}
    </CustomCard>
  );
};
export default BarcodeCard;
